import React, { useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import QuestSeven from "../../components/quote-components/quoteQuestions/QuestSeven";

const QuestionSeven = () => {
  const { closeNavbarMenu } = useNavContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main onMouseOver={closeNavbarMenu}>
      <QuestSeven />
    </main>
  );
};

export default QuestionSeven;
